export { default } from './AppRegistration';
